export function translateStatus(account: {
    active: boolean;
    hidden: boolean;
}): string {
    let res = account.active ? 'Activated' : 'Suspended';
    if (!account.hidden) {
        return res;
    } else {
        return res + ' (Hidden)';
    }
}
